import { readItem } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import type { IncompleteEvent } from '../../../../types/DirectusSchema';
import { directusClient } from '../../services/directusClient/directusClient.ts';
import { parseIncompleteEvent } from '../lib/parseIncompleteEvent.ts';

export const useIncompleteEventsItemQuery = (key?: string) =>
  useQuery({
    enabled: !!key,
    queryKey: ['incomplete_events', key],
    queryFn: async () => {
      const result = await directusClient.request(
        readItem('incomplete_events', key ?? '', {
          fields: [
            '*',
            {
              venue: ['id', 'commercial_name'],
              category: ['id', 'title'],
              target_audiences: ['id', { target_audiences_id: ['*'] }],
              event_details: ['id', { event_details_id: ['*'] }],
            },
          ],
        }),
      );

      return parseIncompleteEvent(result as unknown as IncompleteEvent);
    },
  });
